<template>
  <v-sheet class="pa-3">
    <div data-exp="simple2" class="outputVersion1">
      <div class="header">
        <h1>Terms and Conditions</h1>
        <p>Effective Date: 26th day of February, 2022</p>
        <p>
          These terms and conditions (the "Terms and Conditions") govern the use of
          <span style="font-style: normal; font-weight: bold">https://telemonial.com/</span>
          (the "Site"). This Site is owned and operated by Zach Winters. This Site is a social network. <br /><br />
          By using this Site, you indicate that you have read and understand these Terms and Conditions and agree to
          abide by them at all times.
          <br /><br />
          <span class="all-caps"
            >These Terms and Conditions Contain a dispute resolution clause that impacts your rights about how to
            resovle disputes. Please read it carefully.</span
          >
        </p>
        <div>
          <h2>Intellectual Property</h2>
          <p>
            All content published and made available on our Site is the property of Zach Winters and the Site's
            creators. This includes, but is not limited to images, text, logos, documents, downloadable files and
            anything that contributes to the composition of our Site.
          </p>
        </div>
        <div>
          <h2>User Contributions</h2>
          <p>Users may post the following information on our Site:</p>
          <ul>
            <li>Public comments; and</li>
            <li>Media reviews.<br /></li>
          </ul>
          <p>By posting publicly on our Site, you agree not to act illegally or violate these Terms and Conditions.</p>
        </div>
        <div>
          <h2>Accounts</h2>
          <p>When you create an account on our Site, you agree to the following:</p>
          <ol>
            <li>
              You are solely responsible for your account and the security and privacy of your account, including
              passwords or sensitive information attached to that account; and
            </li>
            <li>
              All personal information you provide to us through your account is up to date, accurate, and truthful and
              that you will update your personal information if it changes.
            </li>
          </ol>
          <p>
            We reserve the right to suspend or terminate your account if you are using our Site illegally or if you
            violate these Terms and Conditions.
          </p>
        </div>
        <div>
          <h2>User Goods and Services</h2>
          <p>
            Our Site allows users to sell goods and services. We do not assume any responsibility for the goods and
            services users sell on our Site. We cannot guarantee the quality or accuracy of any goods and services sold
            by users on our Site. However, if we are made aware that a user is violating these Terms and Conditions, we
            reserve the right to suspend or prohibit the user from selling goods and services on our Site.
          </p>
        </div>
        <div>
          <h2>Links to Other Websites</h2>
          <p>
            Our Site contains links to third party websites or services that we do not own or control. We are not
            responsible for the content, policies, or practices of any third party website or service linked to on our
            Site. It is your responsibility to read the terms and conditions and privacy policies of these third party
            websites before using these sites.
          </p>
        </div>
        <div>
          <h2>Limitation of Liability</h2>
          <p>
            Zach Winters and our directors, officers, agents, employees, subsidiaries, and affiliates will not be liable
            for any actions, claims, losses, damages, liabilities and expenses including legal fees from your use of the
            Site.
          </p>
        </div>
        <div>
          <h2>Indemnity</h2>
          <p>
            Except where prohibited by law, by using this Site you indemnify and hold harmless Zach Winters and our
            directors, officers, agents, employees, subsidiaries, and affiliates from any actions, claims, losses,
            damages, liabilities and expenses including legal fees arising out of your use of our Site or your violation
            of these Terms and Conditions.
          </p>
        </div>
        <div>
          <h2>Applicable Law</h2>
          <p>These Terms and Conditions are governed by the laws of the State of Colorado.</p>
        </div>
        <div>
          <h2>Dispute Resolution</h2>
          <p>
            Subject to any exceptions specified in these Terms and Conditions, if you and Zach Winters are unable to
            resolve any dispute through informal discussion, then you and Zach Winters agree to submit the issue before
            a mediator. The decision of the mediator will not be binding. Any mediator must be a neutral party
            acceptable to both you and Zach Winters.
          </p>
          <p
            style="
              line-height: 18pt;
              font-size: 12pt;
              font-family: Times New Roman, serif;
              color: #000000;
              text-align: Left;
            "
          >
            Notwithstanding any other provision in these Terms and Conditions, you and Zach Winters agree that you both
            retain the right to bring an action in small claims court and to bring an action for injunctive relief or
            intellectual property infringement.
          </p>
        </div>
        <div>
          <h2>Additional Terms</h2>
          <ul>
            <li>
              We do not tolerate objectionable content or abusive users. Our site will actively look into reported users
              and remove them from the site if their content or engagement with other users is deemed to be
              inappropriate, threatening, or harassment.
            </li>
          </ul>
        </div>
        <div>
          <h2>Severability</h2>
          <p>
            If at any time any of the provisions set forth in these Terms and Conditions are found to be inconsistent or
            invalid under applicable laws, those provisions will be deemed void and will be removed from these Terms and
            Conditions. All other provisions will not be affected by the removal and the rest of these Terms and
            Conditions will still be considered valid.
          </p>
        </div>
        <div>
          <h2>Changes</h2>
          <p>
            These Terms and Conditions may be amended from time to time in order to maintain compliance with the law and
            to reflect any changes to the way we operate our Site and the way we expect users to behave on our Site. We
            will notify users by email of changes to these Terms and Conditions or post a notice on our Site.
          </p>
        </div>
        <div>
          <h2>Contact Details</h2>
          <p>Please contact us if you have any questions or concerns. Our contact details are as follows:</p>
          <div class="contact-info">media@telemonial.com</div>

          <p>You can also contact us through the feedback form available on our Site.</p>
        </div>
      </div>
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: "terms-and-conditions.vue",
};
</script>

<style scoped>
.all-caps {
  text-transform: uppercase;
}

.contact-info {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  padding: 8px 0;
  margin-bottom: 16px;
}
</style>
